// Which scenario opens: the one last active, but only when the browser reloaded this very Flip page;
// any other arrival opens the first (Kong, letter 95 item 3) -- README.md ("Active chip").

const KEY_PREFIX = 'reilm.flip.activeScenario.'

// The route the browser actually loaded, read when the bundle first runs, before any in-app navigation.
let loadedHash = typeof window === 'undefined' ? '' : window.location.hash
let reloadTaken = false

const routeOf = (hash) => (hash ?? '').replace(/^#/, '').split('?')[0].replace(/\/+$/, '')

function isBrowserReload() {
  try {
    const entry = window.performance?.getEntriesByType?.('navigation')?.[0]
    if (entry) return entry.type === 'reload'
    // Older engines without Navigation Timing 2: 1 is TYPE_RELOAD.
    return window.performance?.navigation?.type === 1
  } catch {
    return false
  }
}

function read(propertyId) {
  try {
    return window.sessionStorage.getItem(KEY_PREFIX + propertyId)
  } catch {
    return null
  }
}

export function rememberScenario(propertyId, scenarioId) {
  try {
    if (scenarioId) window.sessionStorage.setItem(KEY_PREFIX + propertyId, scenarioId)
    else window.sessionStorage.removeItem(KEY_PREFIX + propertyId)
  } catch {
    // No storage (private mode, blocked site data): a reload simply opens the first scenario.
  }
}

// The stored id to reopen, or null. Only the first Flip mount of a document can get one, so leaving
// the page in-app and coming back opens the first scenario even though the load type stays 'reload'.
export function takeReloadedScenarioId(propertyId) {
  if (reloadTaken) return null
  reloadTaken = true
  if (routeOf(loadedHash) !== `/property/${propertyId}/flip` || !isBrowserReload()) return null
  return read(propertyId)
}

// Tests only: start over as if the document had just loaded at `hash`.
export function resetReloadState(hash = window.location.hash) {
  loadedHash = hash
  reloadTaken = false
}
